/**
 * Phase 3 - Russian translations module
 */
import enBase from './en.js';
import { translationsRu } from '../../utils/translations/translations.ru.js';
import { plansTranslationsRu } from '../../utils/translations/plans/plansTranslations.ru.js';

const merged = { ...enBase, ...translationsRu, ...plansTranslationsRu };
export default merged;
